var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTracking = function SvgTracking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tracking_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.609 1.667A5.83 5.83 0 0 0 4.775 7.5c0 4.375 5.834 10.833 5.834 10.833s5.833-6.458 5.833-10.833a5.83 5.83 0 0 0-5.833-5.833M6.442 7.5c0-2.3 1.867-4.167 4.167-4.167S14.775 5.2 14.775 7.5c0 2.4-2.4 5.992-4.166 8.233C8.875 13.508 6.442 9.875 6.442 7.5"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.87,
    d: "M10.609 9.583a2.083 2.083 0 1 0 0-4.166 2.083 2.083 0 0 0 0 4.166"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tracking_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.609 0h20v20h-20z"
  })))));
};
export default SvgTracking;